import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { formatDateTime } from '../../../utils/dates';
import { GoBackLink } from '../../ImpactClaims/ActiveSubmission/styles';
import { useQuestionnaireTemplates } from '../hooks/useQuestionnaireTemplates';

const formatType = (type: string) =>
  type.replace(/_/g, ' ').replace(/\b(\w)/g, l => l.toUpperCase());

const ActiveQuestionnaireTemplate: React.FC = () => {
  const { templateId } = useParams();
  const { activeTemplate, loading } = useQuestionnaireTemplates({
    activeTemplateId: templateId
  });

  if (loading) {
    return <Box p={2}>Loading...</Box>;
  }

  if (!activeTemplate) {
    return <Box p={2}>Template not found</Box>;
  }

  return (
    <Box p={2}>
      <Box mb={3}>
        <GoBackLink to="/questionnaire-templates">Go back</GoBackLink>
      </Box>
      <Box alignItems="center" display="flex" justifyContent="space-between">
        <h2>{activeTemplate.title}</h2>
      </Box>
      <Card>
        <CardContent>
          <Box mb={2}>
            <Typography color="textSecondary" variant="subtitle2">
              Type
            </Typography>
            <Typography variant="body1">
              {formatType(activeTemplate.questionnaireType)}
            </Typography>
          </Box>
          {activeTemplate.description && (
            <Box mb={2}>
              <Typography color="textSecondary" variant="subtitle2">
                Description
              </Typography>
              <Typography variant="body1">
                {activeTemplate.description}
              </Typography>
            </Box>
          )}
          <Box mb={2}>
            <Typography color="textSecondary" variant="subtitle2">
              Created
            </Typography>
            <Typography variant="body1">
              {formatDateTime(activeTemplate.createdTimestamp)}
            </Typography>
          </Box>
          <Box>
            <Typography color="textSecondary" variant="subtitle2">
              Template Data (JSON^)
            </Typography>
            <Box
              component="pre"
              sx={{
                backgroundColor: 'grey.100',
                borderRadius: 1,
                maxHeight: 400,
                overflow: 'auto',
                p: 2
              }}
            >
              {JSON.stringify(JSON.parse(activeTemplate.templateData), null, 2)}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ActiveQuestionnaireTemplate;
